import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCT_DETAIL_REQUEST,
  FETCH_PRODUCT_DETAIL_SUCCESS,
  FETCH_PRODUCT_DETAIL_FAILURE,
  ADD_PRODUCT_REQUEST,
  ADD_PRODUCT_SUCCESS,
  ADD_PRODUCT_FAILURE,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  SEARCH_PRODUCTS_REQUEST,
  SEARCH_PRODUCTS_SUCCESS,
  SEARCH_PRODUCTS_FAILURE,
  FETCH_ACTIVE_PRODUCTS_REQUEST,
  FETCH_ACTIVE_PRODUCTS_SUCCESS,
  FETCH_ACTIVE_PRODUCTS_FAILURE,
  TOGGLE_PRODUCT_ACTIVE_REQUEST,
  TOGGLE_PRODUCT_ACTIVE_SUCCESS,
  TOGGLE_PRODUCT_ACTIVE_FAILURE,
  FETCH_PRODUCT_STATS_REQUEST,
  FETCH_PRODUCT_STATS_SUCCESS,
  FETCH_PRODUCT_STATS_FAILURE
} from '../types/productTypes';
import api from '../../services/api';

// Fetch Products
export const fetchProductsRequest = () => ({
  type: FETCH_PRODUCTS_REQUEST
});

export const fetchProductsSuccess = (data) => ({
  type: FETCH_PRODUCTS_SUCCESS,
  payload: data
});

export const fetchProductsFailure = (error) => ({
  type: FETCH_PRODUCTS_FAILURE,
  payload: error
});

export const fetchProducts = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchProductsRequest());
    try {
      const response = await api.get('/songs/products/', { params });
      if (response.data.success) {
        dispatch(fetchProductsSuccess(response.data.data));
      } else {
        dispatch(fetchProductsFailure(response.data.message || 'Failed to fetch products'));
      }
    } catch (error) {
      dispatch(fetchProductsFailure(error.response?.data?.message || 'Failed to fetch products'));
    }
  };
};

// Fetch Product Detail
export const fetchProductDetailRequest = () => ({
  type: FETCH_PRODUCT_DETAIL_REQUEST
});

export const fetchProductDetailSuccess = (data) => ({
  type: FETCH_PRODUCT_DETAIL_SUCCESS,
  payload: data
});

export const fetchProductDetailFailure = (error) => ({
  type: FETCH_PRODUCT_DETAIL_FAILURE,
  payload: error
});

export const fetchProductDetail = (productId) => {
  return async (dispatch) => {
    dispatch(fetchProductDetailRequest());
    try {
      const response = await api.get('/songs/products/detail', {
        params: { product_id: productId }
      });
      if (response.data.success) {
        dispatch(fetchProductDetailSuccess(response.data.data));
      } else {
        dispatch(fetchProductDetailFailure(response.data.message || 'Failed to fetch product detail'));
      }
    } catch (error) {
      dispatch(fetchProductDetailFailure(error.response?.data?.message || 'Failed to fetch product detail'));
    }
  };
};

// Add Product
export const addProductRequest = () => ({
  type: ADD_PRODUCT_REQUEST
});

export const addProductSuccess = (product) => ({
  type: ADD_PRODUCT_SUCCESS,
  payload: product
});

export const addProductFailure = (error) => ({
  type: ADD_PRODUCT_FAILURE,
  payload: error
});

export const addProduct = (productData) => {
  return async (dispatch) => {
    dispatch(addProductRequest());
    try {
      const response = await api.post('/songs/products/create', productData);
      if (response.data.success) {
        dispatch(addProductSuccess(response.data.data));
      } else {
        dispatch(addProductFailure(response.data.message || 'Failed to add product'));
      }
    } catch (error) {
      dispatch(addProductFailure(error.response?.data?.message || 'Failed to add product'));
    }
  };
};

// Update Product
export const updateProductRequest = () => ({
  type: UPDATE_PRODUCT_REQUEST
});

export const updateProductSuccess = (product) => ({
  type: UPDATE_PRODUCT_SUCCESS,
  payload: product
});

export const updateProductFailure = (error) => ({
  type: UPDATE_PRODUCT_FAILURE,
  payload: error
});

export const updateProduct = (productId, productData) => {
  return async (dispatch) => {
    dispatch(updateProductRequest());
    try {
      const data = { product_id: productId, ...productData };
      const response = await api.post('/songs/products/update', data);
      if (response.data.success) {
        dispatch(updateProductSuccess(response.data.data));
      } else {
        dispatch(updateProductFailure(response.data.message || 'Failed to update product'));
      }
    } catch (error) {
      dispatch(updateProductFailure(error.response?.data?.message || 'Failed to update product'));
    }
  };
};

// Delete Product
export const deleteProductRequest = () => ({
  type: DELETE_PRODUCT_REQUEST
});

export const deleteProductSuccess = (productId) => ({
  type: DELETE_PRODUCT_SUCCESS,
  payload: productId
});

export const deleteProductFailure = (error) => ({
  type: DELETE_PRODUCT_FAILURE,
  payload: error
});

export const deleteProduct = (productId) => {
  return async (dispatch) => {
    dispatch(deleteProductRequest());
    try {
      const data = { product_id: productId };
      await api.post('/songs/products/delete', data);
      dispatch(deleteProductSuccess(productId));
    } catch (error) {
      dispatch(deleteProductFailure(error.response?.data?.message || 'Failed to delete product'));
    }
  };
};

// Search Products
export const searchProductsRequest = () => ({
  type: SEARCH_PRODUCTS_REQUEST
});

export const searchProductsSuccess = (data) => ({
  type: SEARCH_PRODUCTS_SUCCESS,
  payload: data
});

export const searchProductsFailure = (error) => ({
  type: SEARCH_PRODUCTS_FAILURE,
  payload: error
});

export const searchProducts = (query, params = {}) => {
  return async (dispatch) => {
    dispatch(searchProductsRequest());
    try {
      const searchParams = { query, ...params };
      const response = await api.get('/songs/products/search', { params: searchParams });
      if (response.data.success) {
        dispatch(searchProductsSuccess(response.data.data));
      } else {
        dispatch(searchProductsFailure(response.data.message || 'Failed to search products'));
      }
    } catch (error) {
      dispatch(searchProductsFailure(error.response?.data?.message || 'Failed to search products'));
    }
  };
};

// Fetch Active Products
export const fetchActiveProductsRequest = () => ({
  type: FETCH_ACTIVE_PRODUCTS_REQUEST
});

export const fetchActiveProductsSuccess = (data) => ({
  type: FETCH_ACTIVE_PRODUCTS_SUCCESS,
  payload: data
});

export const fetchActiveProductsFailure = (error) => ({
  type: FETCH_ACTIVE_PRODUCTS_FAILURE,
  payload: error
});

export const fetchActiveProducts = () => {
  return async (dispatch) => {
    dispatch(fetchActiveProductsRequest());
    try {
      const response = await api.get('/songs/products/active');
      if (response.data.success) {
        dispatch(fetchActiveProductsSuccess(response.data.data));
      } else {
        dispatch(fetchActiveProductsFailure(response.data.message || 'Failed to fetch active products'));
      }
    } catch (error) {
      dispatch(fetchActiveProductsFailure(error.response?.data?.message || 'Failed to fetch active products'));
    }
  };
};

// Toggle Product Active Status
export const toggleProductActiveRequest = () => ({
  type: TOGGLE_PRODUCT_ACTIVE_REQUEST
});

export const toggleProductActiveSuccess = (product) => ({
  type: TOGGLE_PRODUCT_ACTIVE_SUCCESS,
  payload: product
});

export const toggleProductActiveFailure = (error) => ({
  type: TOGGLE_PRODUCT_ACTIVE_FAILURE,
  payload: error
});

export const toggleProductActive = (productId) => {
  return async (dispatch) => {
    dispatch(toggleProductActiveRequest());
    try {
      const data = { product_id: productId };
      const response = await api.post('/songs/products/toggle-active', data);
      if (response.data.success) {
        dispatch(toggleProductActiveSuccess(response.data.data));
      } else {
        dispatch(toggleProductActiveFailure(response.data.message || 'Failed to toggle product status'));
      }
    } catch (error) {
      dispatch(toggleProductActiveFailure(error.response?.data?.message || 'Failed to toggle product status'));
    }
  };
};

// Fetch Product Statistics
export const fetchProductStatsRequest = () => ({
  type: FETCH_PRODUCT_STATS_REQUEST
});

export const fetchProductStatsSuccess = (data) => ({
  type: FETCH_PRODUCT_STATS_SUCCESS,
  payload: data
});

export const fetchProductStatsFailure = (error) => ({
  type: FETCH_PRODUCT_STATS_FAILURE,
  payload: error
});

export const fetchProductStats = () => {
  return async (dispatch) => {
    dispatch(fetchProductStatsRequest());
    try {
      const response = await api.get('/songs/products/stats');
      if (response.data.success) {
        dispatch(fetchProductStatsSuccess(response.data.data));
      } else {
        dispatch(fetchProductStatsFailure(response.data.message || 'Failed to fetch product statistics'));
      }
    } catch (error) {
      dispatch(fetchProductStatsFailure(error.response?.data?.message || 'Failed to fetch product statistics'));
    }
  };
};
